import React, { FunctionComponent } from "react";
import DynamicImage from "components/dynamicImage";
import "./index.scss";
import ContentItem from "../../components/content/ContentItem";
import EmblaCarousel from "../../components/EmblaCarousel";

import {
  Image,
  ContentPageItemCollection,
} from "../../services/entities/content";

type HeroMediaProps = {
  images?: URL | Image | Image[] | null;
  code?: string | null;
};

export const HeroMedia: FunctionComponent<HeroMediaProps> = ({
  images = null,
  code = "heroMedia",
}) => {
  return (
    <section className={`section--hero-media`}>
      <span className="banner-image">
        {images && (images as URL) && (
          <div className="image-wrapper">
            <img src={(images as URL).href} alt="" />
          </div>
        )}

        {images && (images as Image[] | Image) && Array.isArray(images) && (
          <EmblaCarousel
            loop={true}
            hasDots={false}
            largeNavArrows={false}
            align={1}
            hasThumbs={false}
            // variant={variant}
          >
            {(images as Image[]).map((item: Image) => {
              return (
                <div className="image-wrapper" key={item.url}>
                  <img src={item.url} alt="" />
                </div>
              );
            })}
          </EmblaCarousel>
        )}
        {code && (
          <ContentItem code={code}>
            {(item) => {
              return (
                <DynamicImage
                  item={(item as ContentPageItemCollection).image}
                />
              );
            }}
          </ContentItem>
        )}
      </span>
    </section>
  );
};

export default HeroMedia;
